import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { makeStyles, Theme } from '@material-ui/core';

interface props {
  filteredLecturers: any;
}

export const LecturerList = ({ filteredLecturers }: props) => {
  const classes = useStyles({});

  return (
    <div>
      <div className={classes.title}>
        <FormattedMessage
          id="components.inCall.participantList.lecturerLabel"
          description="In call participant list lecturer label"
          defaultMessage={'Lecturer:'}
        />
      </div>
      {filteredLecturers.length ? (
        filteredLecturers.map((m, index) => (
          <p data-testid="lecturer" key={`lecturer-${index}`}>
            {m.name}
          </p>
        ))
      ) : (
        <p data-testid="lecturer">
          <FormattedMessage
            id="components.inCall.participantList.noSearchResultsLecturers"
            defaultMessage={'No lecturers matched your search'}
          />
        </p>
      )}
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    fontWeight: theme.typography.fontWeightBold
  }
}));

export default injectIntl(LecturerList);
